import { Flex, Text, type TextProps } from "@chakra-ui/react";
import {
  type FA12TokenBalance,
  type FA2TokenBalance,
  tokenNameSafe,
  verifiedTokens,
} from "@umami/chains";

import { VerifiedIcon } from "../../assets/icons";
import { useColor } from "../../styles/useColor";

export const TokenNameWithIcon = ({
  token,
  ...textProps
}: { token: FA12TokenBalance | FA2TokenBalance } & TextProps) => {
  const color = useColor();

  const isVerified = verifiedTokens.includes(token.contract);

  return (
    <Flex alignItems="center">
      <Text {...textProps} marginRight="4px">
        {tokenNameSafe(token)}
      </Text>
      {isVerified && <VerifiedIcon color={color("white")} />}
    </Flex>
  );
};
